export const StyledRteTheme = {
  // variabili antd
  colorText: 'rgba(0, 0, 0, 0.88)',
  fontSize: 14,
  fontSizeSM: 12,
  fontSizeLG: 16,
  lineHeight: 1.571_428_571_428_571_4,
  colorBgContainer: '#ffffff',
  colorBorder: '#d9d9d9',
  borderRadius: 6,
  borderRadiusSM: 4,
  borderRadiusLG: 8,

  colorPrimary: '#4557b7',
  colorPrimaryHover: '#4096ff',
  controlOutlineWidth: 2,
  controlOutline: 'rgba(5, 145, 255, 0.1)',

  colorLink: '#4557B7',
  colorLinkHover: '#69b1ff',
  colorLinkActive: '#0958d9',

  colorError: '#ff4d4f',
  colorErrorBorderHover: '#ffa39e',
  colorErrorOutline: 'rgba(255, 38, 5, 0.06)',

  colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
  colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',

  // colore accento
  defaultAccentColor: '#cd9a02',

  // variabili custom
  rteHtmlTagMarginBottom: 0.4,
};
